import { render, staticRenderFns } from "./OsReportContentEditor.vue?vue&type=template&id=00530390&scoped=true"
import script from "./OsReportContentEditor.vue?vue&type=script&lang=ts"
export * from "./OsReportContentEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00530390",
  null
  
)

export default component.exports